// banner 展示图选择逻辑
// showType === 1: 展示封面图 contentCoverUrl
// showType === 2: 展示自定义背景图 backgroundImageUrl
// 未配置 showType 时沿用旧逻辑: 优先 backgroundImageUrl, 缺省回退 contentCoverUrl
export function getBannerImage(record: any): string {
  if (record?.showType === 1)
    return record?.contentCoverUrl || record?.backgroundImageUrl || ''
  return record?.backgroundImageUrl || record?.contentCoverUrl || ''
}
